import { Event } from '@/types'
import { isWithSessionAssistant } from '@/utils/parrot'

export const canUseScriptForEvent = (event: Event): boolean =>
  !isWithSessionAssistant(event)
